import PlgScreenAdView from "shared-assets/collect-payment-ui/plg-screen/PlgScreenAdView";

angular
  .module("kareo.ui.shared.directives.plg-screen-panel", ['react'])
  .directive('plgScreenPanel', plgScreenShow);

plgScreenShow.$inject = ['reactDirective'];
function plgScreenShow(reactDirective) {

  return reactDirective(PlgScreenAdView);
}
